import { PriceRangeFilter } from '../price-range';
import CitiesDropdown from '../filters-cities-dropdown';
import Checkboxes from '../grouped-checkbox/checkboxes';
import { GroupedCheckbox } from '../grouped-checkbox';
import { Translate } from '~/i18n';
import { Region } from '~/components/home-page/cities-slider';
import { FilterCategory } from '~/interfaces/filters';
import { useRouter } from 'next/router';
import { debounce } from 'lodash';

type AdvancedFiltersListProps = {
   regions: Region[];
   categories: FilterCategory[];
   limit: number;
   toggleShowCategories: () => void;
   showCategories: boolean;
   mobile?: boolean;
   // eslint-disable-next-line no-unused-vars
   onItemChange: (name: string, values: any) => void;
   // eslint-disable-next-line no-unused-vars
   onCategoryChange: (params: {
      name: string;
      checked: boolean;
      type: string;
      childs?: any[];
   }) => void;
   // Only used in mobile mode
   values?: Record<string, any>;
};

export const AdvancedFiltersList = ({
   categories,
   regions,
   limit,
   toggleShowCategories,
   showCategories,
   mobile,
   onItemChange,
   onCategoryChange,
   values,
}: AdvancedFiltersListProps) => {
   const router = useRouter();

   const priceChangeHandler = debounce(vals => onItemChange('price', vals), 500);

   const featuredCategories = categories.length
      ? categories.filter((category: any) => category && category?.total_venues > 0)
      : [];

   return (
      <div>
         <div className="mb-7">
            <PriceRangeFilter
               handleValues={priceChangeHandler}
               labelClassName="mt-[21px]"
               rangeClassName="ltr:pl-3 rtl:pr-3 w-[245px]"
               values={values?.price?.split(',')}
            />
         </div>
         <div className="mb-5">
            <Checkboxes
               id={'offers' + (mobile ? '-mobile' : '')}
               name="offers"
               label={<Translate id="filters:only offers" />}
               onChange={onItemChange}
               value={values?.offers}
            />
         </div>

         <div className="mb-7">
            <div className="mb-3 font-bold">
               <Translate id="auth:select city" />
            </div>
            <div className="relative z-10">
               <CitiesDropdown
                  regions={regions}
                  desktopMode
                  defaultValue={values?.location || String(router.query.location) || ''}
                  onChange={href => onItemChange('location', href)}
               />
            </div>
         </div>
         <div className="mb-7">
            <div className="mb-3 font-bold">
               <Translate id="filters:category" />
            </div>
            {[...featuredCategories.slice(0, limit)].map(
               ({ title, _id, sub_categories, slugs, total_venues }, idx, arr) => {
                  if (sub_categories?.length) {
                     return (
                        <GroupedCheckbox
                           key={_id}
                           label={title}
                           mobile={mobile}
                           name={slugs?.en}
                           childs={sub_categories}
                           id={title + (mobile ? '-mobile' : '')}
                           last={idx === arr.length - 1}
                           value={values?.['category']?.split(',').includes(slugs?.en)}
                           sub_values={values?.['sub-category']?.split(',')}
                           count={total_venues}
                           onChange={(name, checked, childs) =>
                              onCategoryChange({ checked, name, type: 'category', childs })
                           }
                           onChildChange={(name, checked) =>
                              onCategoryChange({ checked, name, type: 'sub-category' })
                           }
                        />
                     );
                  }
                  return (
                     <Checkboxes
                        id={title + (mobile ? '-mobile' : '')}
                        key={`${_id}-category`}
                        name={slugs?.en}
                        label={title}
                        count={total_venues}
                        value={values?.['category']?.split(',').includes(slugs?.en)}
                        onChange={(name, checked) =>
                           onCategoryChange({ checked, name, type: 'category' })
                        }
                     />
                  );
               }
            )}
            {featuredCategories.length > limit ? (
               <button
                  className="text-sm font-bold underline focus:outline-none focus:opacity-60"
                  onClick={toggleShowCategories}>
                  {!showCategories ? (
                     <Translate id="common:show all" />
                  ) : (
                     <Translate id="common:hide" />
                  )}
               </button>
            ) : null}
         </div>
         <div className="mb-7">
            <div className="mb-3 font-bold">
               <Translate id="filters:gender" />
            </div>
            <Checkboxes
               id={'males' + (mobile ? '-mobile' : '')}
               name="males"
               label={<Translate id="filters:only for males" />}
               onChange={onItemChange}
               value={values?.gender?.split(',').includes('males')}
            />
            <Checkboxes
               id={'females' + (mobile ? '-mobile' : '')}
               name="females"
               label={<Translate id="filters:only for females" />}
               onChange={onItemChange}
               value={values?.gender?.split(',').includes('females')}
            />
         </div>
         {/* <div className="mb-5">
            <div className="mb-3 font-bold">
               <Translate id="filters:experience type" />
            </div>
            {[
               'internal',
               'external',
               '24_hours_confirmation',
               'online_experience',
               'offline_experience',
            ].map(item => (
               <Checkboxes
                  key={item}
                  id={item + (mobile ? '-mobile' : '')}
                  name={item}
                  label={<Translate id={`filters:${item}`} />}
                  onChange={onItemChange}
                  value={values?.suitable?.split(',').includes(item)}
               />
            ))}
         </div> */}
      </div>
   );
};
